"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("next/router");
const ru_json_1 = __importDefault(require("../locales/ru.json"));
const en_json_1 = __importDefault(require("../locales/en.json"));
const cn_json_1 = __importDefault(require("../locales/cn.json"));
const react_1 = require("react");
const cookies_next_1 = require("cookies-next");
const useLocalization = () => {
    const router = (0, router_1.useRouter)();
    (0, react_1.useEffect)(() => {
        if (router.locale !== (0, cookies_next_1.getCookie)('lang')) {
            (0, cookies_next_1.setCookie)('lang', router.locale);
        }
    }, [router]);
    const json2object = (json) => JSON.parse(JSON.stringify(json));
    switch (router.locale) {
        case 'ru':
            return json2object(ru_json_1.default);
        case 'en':
            return json2object(en_json_1.default);
        case 'cn':
            return json2object(cn_json_1.default);
        default:
            return json2object(ru_json_1.default);
    }
};
exports.default = useLocalization;
